import React from 'react';
import clsx from 'clsx';

export const InlineSnippet = ({ className, children }) => {
  return (
    <span
      className={clsx(
        'inline-block rounded-md bg-orange-100 px-1 py-0.5 text-black',
        className,
      )}
    >
      {children}
    </span>
  );
};
